import axios from 'axios';
import { API_URL, AUTH_TOKEN_KEY } from './config';
import { refresh } from './refresh';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['X-Client-Domain'] = window.location.origin;
    return config;
  },
  (error) => Promise.reject(error)
);

const isAuthEndpoint = (url) => {
  if (!url) return false;
  return /\/api\/auth\/(login|refresh-token|logout)(\?|$|\/)/.test(url);
};

const emitSessionExpired = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  window.dispatchEvent(new Event('auth:session-expired'));
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status !== 401) return Promise.reject(error);

    const originalRequest = error.config;
    if (!originalRequest || originalRequest._retry) return Promise.reject(error);
    if (isAuthEndpoint(originalRequest.url)) return Promise.reject(error);

    originalRequest._retry = true;

    try {
      const data = await refresh();
      const newToken = data?.tokens?.accessToken;
      if (!newToken) throw new Error('Refresh returned no token');
      originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
      return api(originalRequest);
    } catch (refreshError) {
      if (refreshError?.response?.status === 401) {
        emitSessionExpired();
      }
      return Promise.reject(refreshError);
    }
  }
);

export default api;
